/*
 * @Author: your name
 * @Date: 2020-10-14 13:50:09
 * @LastEditTime: 2022-01-27 15:30:41
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Ed
 * @FilePath: \vue3-element-admin\src\main.js
 */
import { createApp } from "vue";
import axios from "@/plugins/axios";
import App from "@/App.vue";
import router from "@/router";
import store from "@/store";
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import elementIcon from "@/plugins/svgicon";
import permission from "@/plugins/permission";
import mock from "@/plugins/mock";
import directives from "@/directives";
import 'vant/lib/index.css';
// import "jsoneditor"; // 移除jsoneditor全局导入，改为按需导入
import veBaseComponents from "@/components/veBaseComponents";

import "normalize.css/normalize.css";
import "nprogress/nprogress.css";
import "@/styles/common.scss";


// 全局引入 xe-utils
import XE from 'xe-utils'
window.XE = XE
const app = createApp(App);

app.use(mock)
    .use(elementIcon)
    .use(veBaseComponents)
    .use(store)
    .use(router)
    .use(ElementPlus, { locale: zhCn, zIndex: 3000 })
    .use(axios, { router, store, opt: "VE_API" })
    .use(permission, { router, store })
    .use(directives, { router, store })
    .mount("#app");
